import { z } from 'zod';
import { DataSetVersion } from 'libs/end-to-end/src/types/databases/data-sets/data-set-version';

export const CreateDataSetVersionSchema = DataSetVersion.omit({
  dataSetVersion: true,
  error: true,
});

export type CreateDataSetVersionBodyType = z.infer<
  typeof CreateDataSetVersionSchema
>;
